import { defineMessages } from 'react-intl';

import { fieldNames } from './model';

export const labels = defineMessages({
  [fieldNames.socialLinks]: {
    id: `graphql.UpdateSocialLinks.labels.socialLinks`,
    defaultMessage: 'Social Links',
  },
});

export const header = defineMessages({
  title: {
    id: 'graphql.UpdateSocialLinks.header.title',
    defaultMessage: 'Social Links',
  },
});

export const buttons = defineMessages({
  submit: {
    id: 'users.personal-details-form.buttons.submit',
    defaultMessage: 'Update Personal Details',
  },
});

export const instructions = defineMessages({
  ensureCriteria: {
    id: 'users.edit-basic-info.ensure-criteria',
    defaultMessage: 'Please ensure that your image satisfies the following criteria:',
  },
  fileSize: {
    id: 'users.edit-basic-info.file-size',
    defaultMessage: 'File size should be less than {maxFileSize}',
  },
  fileType: {
    id: 'users.edit-basic-info.file-type',
    defaultMessage: 'File type should be either PNG or JPEG/JPG.',
  },
  aspectRatio: {
    id: 'users.edit-basic-info.aspect-ratio',
    defaultMessage: 'The image should have a 1:1 aspect ratio (i.e. be square format).',
  },
});



// WEBPACK FOOTER //
// ./src/ui/graphql/UpdateSocialLinks/messages.js